import { createSelector } from "reselect";
import getDomain from "../base_getters/get_domain";

const getFilesById = createSelector([
  getDomain
], (domain) => domain.files.byId);

export default getFilesById
